// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

// @add your types

export enum UserFormInputs {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  USERNAME = 'username',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
  DOC_NUMBER = 'doc_number',
  DOC_TYPE = 'doc_type',
  PROGRAMMING_CODE = 'programming_code',
  PASSWORD = 'password',
  TIMEZONE = 'timezone',
  DIALECT = 'dialect',
  ROLES = 'roles'
}

export interface ICompanyUser {
  _id: string;
  name: string;
  description: string
}
export interface INewUser {
  username?: string,
  password?: string
  profile?: any,
  roles?: [],
  company?: ICompanyUser
}

export interface IUserListItem {
  _id: string
  username?: string,
  password?: string
  profile?: any,
  roles?: [],
  company?: ICompanyUser
  admin_company?: boolean
}

export interface IParamsListUsers{
  pageNumber?: string, // Numero de pagina
  nPerPage?: string, // Cantidad de elementos por pagina
  select?: string, // Campos de la coleccion a buscar
  search?: string, // Busca sobre los campos de la coleccion
  roles?: Array<string> | string // Roles
  role_names?: Array<string> | string // Roles
  company?: string // Identificador de compañia
  sort?: string // Parámetro para ordenar
  without_company?: boolean | string
}

export interface IUsersHttpResponse extends IHttpResponse {
  users: IUserListItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}
//@end
